import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PipelineRun, ContentSourceType } from '../../types';

@Component({
  standalone: false,
  selector: 'mkt-run-card',
  template: `
    <div class="mkt-run-card" (click)="selectRun.emit()">
      <div class="mkt-run-card__icon">
        <i [class]="sourceTypeIcon"></i>
      </div>
      <div class="mkt-run-card__body">
        <h4 class="mkt-run-card__title">{{ run.contentSource.Title }}</h4>
        <div class="mkt-run-card__meta">
          <span *ngIf="run.contentSource.Speaker"><i class="fa-solid fa-user"></i> {{ run.contentSource.Speaker }}</span>
          <span *ngIf="run.contentSource.SourceDate"><i class="fa-solid fa-calendar"></i> {{ run.contentSource.SourceDate | date }}</span>
          <span><i class="fa-solid fa-file-lines"></i> {{ run.blogs.length }} post{{ run.blogs.length !== 1 ? 's' : '' }}</span>
        </div>
        <div class="mkt-run-card__status">
          {{ approvedCount }}/{{ run.blogs.length }} approved
        </div>
      </div>
      <div class="mkt-run-card__arrow">
        <i class="fa-solid fa-chevron-right"></i>
      </div>
    </div>
  `,
  styles: [`
    .mkt-run-card {
      display: flex;
      align-items: center;
      gap: 14px;
      background: var(--mj-bg-surface);
      border: 1px solid var(--mj-border-default);
      border-radius: 8px;
      padding: 14px 16px;
      cursor: pointer;
      transition: box-shadow 0.2s ease, border-color 0.2s ease;
    }
    .mkt-run-card:hover {
      box-shadow: var(--mj-shadow-sm);
      border-color: var(--mj-brand-primary);
    }
    .mkt-run-card__icon {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      background: var(--mj-status-info-bg);
      color: var(--mj-brand-primary);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.1rem;
      flex-shrink: 0;
    }
    .mkt-run-card__body {
      flex: 1;
      min-width: 0;
    }
    .mkt-run-card__title {
      margin: 0 0 4px;
      font-size: 0.95rem;
      font-weight: 600;
      color: var(--mj-text-primary);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .mkt-run-card__meta {
      display: flex;
      gap: 12px;
      font-size: 0.78rem;
      color: var(--mj-text-muted);
      flex-wrap: wrap;
    }
    .mkt-run-card__meta i {
      margin-right: 3px;
    }
    .mkt-run-card__status {
      margin-top: 4px;
      font-size: 0.75rem;
      color: var(--mj-status-success-text);
      font-weight: 500;
    }
    .mkt-run-card__arrow {
      color: var(--mj-text-disabled);
      font-size: 0.85rem;
      flex-shrink: 0;
    }
  `]
})
export class RunCardComponent {
  @Input() run!: PipelineRun;
  @Input() contentSourceTypes: ContentSourceType[] = [];
  @Output() selectRun = new EventEmitter<void>();

  get sourceTypeIcon(): string {
    const typeName = this.contentSourceTypes.find(t => t.ID === this.run.contentSource.ContentSourceTypeID)?.Name ?? '';
    switch (typeName) {
      case 'Podcast Transcript': return 'fa-solid fa-podcast';
      case 'Webinar Recording': return 'fa-solid fa-video';
      case 'Document': return 'fa-solid fa-file-lines';
      default: return 'fa-solid fa-file';
    }
  }

  get approvedCount(): number {
    return this.run.blogs.filter(b => b.Status === 'Ready' || b.Status === 'Published').length;
  }
}
